import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import Currency from "slotworks/i18n/currency";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import { SoundEvent } from "slotworks/sound/sound-events";
import SoundManager from "slotworks/sound/sound-manager";
import Contract from "slotworks/utils/contract";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import { PlaySymbolSoundCommand } from "../../commands/symbols/play-symbol-sound-command";
import gameState from "slotworks/model/game-state";
import settingsModel from "slotworks/model/settings/settings-model";
import soundManager from "slotworks/sound/sound-manager";

export default class CelebrateWinComponent {

    public TOTAL_COUNTUP_TIME: number = 750;
    public TOTAL_WAIT_TIME: number = 750;
    public LINE_COUNTUP_TIME: number = 0;
    public LINE_WAIT_TIME: number = 1250;

    private tween: TweenJS.Tween;
    private timer: number;

    private tickUpComplete: boolean;
    private transitionComplete: boolean;
    private completeResolve: Function;

    // TODO: This class could definitly benefit from some reuse refactoring
    public totalWin(win: number) {
        return new Contract<void>((resolve) => {
            this.tickUpComplete = this.transitionComplete = false;

            this.completeResolve = () => resolve(null);
            this.hide();

            let scene: string;

            const noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(noWinWin) {
                scene = Layers.CelebrationContent.hasScene("lowWin") ? "lowWin" : "totalWin";
            } else {
                scene = "totalWin";
            }

            if (win <= 0 || !Layers.CelebrationContent.hasScene(scene)) {
                resolve(null);
                return;
            }

            const setup = () => {
                Components.footer.showGameWin(win);
                if(noWinWin) {
                    SoundManager.event(SoundEvent.symbol_win_below_threshold);
                    this.display(Layers.CelebrationContent.getText("value"), win, this.TOTAL_COUNTUP_TIME+this.TOTAL_WAIT_TIME)
                } else {
                    SoundManager.event(SoundEvent.tickup_totalwin_start);
                    this.tickUp(Layers.CelebrationContent.getText("value"), win, this.TOTAL_COUNTUP_TIME, this.TOTAL_WAIT_TIME);
                }
            };

            Layers.CelebrationContent.setScene(scene, setup).then(() => {
                this.transitionComplete = true;
                this.complete();
            });
        });
    }

    public singleTotalWin(win: number, result: LineResult) {
        return new Contract<void>((resolve) => {
            this.tickUpComplete = this.transitionComplete = false;

            this.completeResolve = () => resolve(null);
            this.hide();

            let scene: string;

            const noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(noWinWin) {
                scene = Layers.CelebrationContent.hasScene("lowWin") ? "lowWin" : "totalWin";
            } else {
                scene = "totalWin";
            }

            if (win <= 0 || !Layers.CelebrationContent.hasScene(scene)) {
                resolve(null);
                return;
            }

            const setup = () => {
                Components.footer.showGameWin(win);
                if(noWinWin) {
                    SoundManager.event(SoundEvent.symbol_win_below_threshold);
                    this.display(Layers.CelebrationContent.getText("value"), win, this.TOTAL_COUNTUP_TIME+this.TOTAL_WAIT_TIME);
                } else {
                    PlaySymbolSoundCommand(result.symbolType, result.matches.toString(), "1");
                    this.tickUp(Layers.CelebrationContent.getText("value"), win, this.TOTAL_COUNTUP_TIME, this.TOTAL_WAIT_TIME);
                }
            };

            Layers.CelebrationContent.setScene(scene, setup).then(() => {
                this.transitionComplete = true;
                this.complete();
            });
        });
    }

    public additionalWin(win: number) {
        return new Contract<void>((resolve) => {
            this.hide();

            if (win <= 0 || !Layers.CelebrationContent.getFirstValidScene(["additionalWin", "totalWin"])) {
                resolve(null);
                return;
            }

            const noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();

            const setup = () => {
                if(noWinWin) {
                    SoundManager.event(SoundEvent.symbol_win_below_threshold);
                } else {
                    SoundManager.event(SoundEvent.tickup_totalwin_start);
                }
                Components.footer.showGameWin(win);
                Layers.CelebrationContent.getText("value").text = Currency.format(win, undefined, undefined, true);
            };

            Layers.CelebrationContent.setScene(Layers.CelebrationContent.getFirstValidScene(["additionalWin", "totalWin"]), setup).then(() => {

                this.timer = Timer.setTimeout(() => {
                    Layers.CelebrationContent.defaultScene().then(resolve);
                }, this.TOTAL_WAIT_TIME);
            });
        });
    }

    public lineWin(win: number, line?: number, symbol?: string, matches?: number, row?: number, noRestore?: boolean) {
        return new Contract<void>((resolve) => {
            this.tickUpComplete = this.transitionComplete = false;
            this.completeResolve = () => resolve(null);

            this.hide();
            const noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();

            if (win <= 0) {
                resolve(null);
                return;
            }

            const scene = Layers.CelebrationContent.getFirstValidScene([`line_${line}_${matches}_win`, `line_${line}_win`, `line_row_${row}_win`, "line_win", "lineWin"]);
            if (scene) {
                const setup = () => {                    
                    Components.footer.showLineWin(line, win, symbol, matches);
                    if(noWinWin) {
                    //    SoundManager.event(SoundEvent.symbol_win_below_threshold);
                        this.display(Layers.CelebrationContent.getText("value"), win, this.LINE_COUNTUP_TIME+this.LINE_WAIT_TIME, noRestore);
                    } else {
                        SoundManager.event(SoundEvent.tickup_linewin_start);
                        this.tickUp(Layers.CelebrationContent.getText("value"), win, this.LINE_COUNTUP_TIME, this.LINE_WAIT_TIME);
                    }
                };

                Layers.CelebrationContent.setScene(scene, setup).then(() => {
                    this.transitionComplete = true;
                    this.complete(noRestore);
                });
            } else {
                if(noWinWin) {
                    this.waitWin(this.LINE_COUNTUP_TIME+this.LINE_WAIT_TIME);
                } else 
                    resolve(null);
            }
        });
    }

    public hide() {
        if (this.tween) {
            SoundManager.event(SoundEvent.tickup_anywin_end);
            this.tween.stop();
        }
        Timer.clearTimeout(this.timer);

        Layers.CelebrationContent.jumpToScene("default");
    }

    private tickUp(text: PIXI.Text, targetValue: number, duration: number, wait: number) {
        SoundManager.event(SoundEvent.tickup_anywin_start);

        const tickObj = {
            value: 0
        };
        this.tween = new TweenJS.Tween(tickObj)
            .to({value: targetValue}, duration)
            .onUpdate(() => {
                text.text = Currency.format(tickObj.value, undefined, undefined, true, true);
            })
            .onComplete(() => {
                text.text = Currency.format(tickObj.value, undefined, undefined, true);

                SoundManager.event(SoundEvent.tickup_anywin_end);

                this.timer = Timer.setTimeout(() => {
                    this.tickUpComplete = true;
                    this.complete();
                }, wait);
            })
            .start();
    }

    private display(text: PIXI.Text, value: number, wait: number, noRestore?: boolean) {
        text.text = Currency.format(value, undefined, undefined, true);        
        this.timer = Timer.setTimeout(() => {
            this.tickUpComplete = true;
            this.transitionComplete = true;
            this.complete(noRestore);
        }, wait);
    }

    private waitWin(wait: number) {
        this.timer = Timer.setTimeout(() => {
            this.tickUpComplete = true;
            this.transitionComplete = true;
            this.complete(true);
        }, wait);
    }

    private complete(noRestore: boolean = false) {
        if (this.tickUpComplete && this.transitionComplete) {
            if(noRestore === true) {
                this.completeResolve();
            } else
                Layers.CelebrationContent.defaultScene().then(() => this.completeResolve());
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/celebrate-win/celebrate-win-component.ts